/* Duration Wellness — theme.js */
document.addEventListener('DOMContentLoaded', function () {

  /* ── DRAG SCROLL ── */
  function makeDraggable(el) {
    if (!el) return;
    var isDown = false, startX, scrollLeft;
    el.addEventListener('mousedown', function (e) {
      isDown = true; startX = e.pageX - el.offsetLeft; scrollLeft = el.scrollLeft;
      el.style.cursor = 'grabbing';
    });
    el.addEventListener('mouseleave', function () { isDown = false; el.style.cursor = 'grab'; });
    el.addEventListener('mouseup', function () { isDown = false; el.style.cursor = 'grab'; });
    el.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - el.offsetLeft;
      var walk = (x - startX) * 1.4;
      el.scrollLeft = scrollLeft - walk;
    });
  }
  makeDraggable(document.getElementById('productScroll'));
  makeDraggable(document.getElementById('expertScroll'));

  /* ── TESTIMONIAL ROTATOR ── */
  var quotes = document.querySelectorAll('.testimonial-quote');
  var authors = document.querySelectorAll('.testimonial-author');
  var dots = document.querySelectorAll('.t-dot');
  var current = 0;
  var autoTimer;

  function showTestimonial(index) {
    quotes.forEach(function (q, i) {
      q.style.opacity = '0';
      setTimeout(function () {
        if (i === index) {
          q.classList.remove('hidden-testimonial');
          q.style.opacity = '1';
        } else {
          q.classList.add('hidden-testimonial');
        }
      }, 200);
    });
    authors.forEach(function (a, i) {
      a.classList.toggle('hidden-testimonial', i !== index);
    });
    dots.forEach(function (d, i) { d.classList.toggle('active', i === index); });
    current = index;
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      clearInterval(autoTimer);
      showTestimonial(i);
      startAuto();
    });
  });

  function startAuto() {
    autoTimer = setInterval(function () {
      showTestimonial((current + 1) % (dots.length || 1));
    }, 5000);
  }

  if (quotes.length > 1) {
    quotes.forEach(function (q) { q.style.transition = 'opacity .3s'; });
    startAuto();
  }

  /* ── CART COUNT ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('.cart-count');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function () {});
  }
  updateCartCount();

  /* ── AJAX ADD TO CART ── */
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.add-btn');
      var variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;
      var original = btn.textContent;
      btn.textContent = 'Adding\u2026';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantInput.value, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        updateCartCount();
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
      })
      .catch(function () { btn.textContent = original; btn.disabled = false; });
    });
  });

  /* ── HEADER SCROLL SHADOW ── */
  var hdr = document.querySelector('header');
  if (hdr) {
    window.addEventListener('scroll', function () {
      hdr.style.boxShadow = window.scrollY > 60
        ? '0 2px 24px rgba(0,0,0,0.07)'
        : 'none';
    }, { passive: true });
  }

  /* ── VARIANT SELECT on product pages ── */
  var variantSelect = document.querySelector('select[name="id"]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var addBtn = document.querySelector('.add-btn');
      var selected = variantSelect.options[variantSelect.selectedIndex];
      if (addBtn) {
        if (selected && selected.disabled) {
          addBtn.textContent = 'Sold Out';
          addBtn.disabled = true;
        } else {
          addBtn.textContent = 'Add to Cart';
          addBtn.disabled = false;
        }
      }
    });
  }

});
